export default __webpack_public_path__ + "static/media/ch-photo.01c0aadb.jpeg";